export default "__VITE_ASSET__CLpZlzYJ__"